import { getPatientDetailsDataByTabWise } from "../screens/patient-screen/patientSaga";

export const getHealthHistory = (patientId: string, dispatch: any) => {
  const payload = {
    apiQuery: patientId
      ? `patient/${patientId}?searchCriteria=${encodeURIComponent("health-history")}`
      : null, // Or handle a default value
    selectedTab: "healthHistory",
  };
  if (patientId) {
    dispatch(getPatientDetailsDataByTabWise(payload));
  }
};
